import type { Campaign, User } from '../../types';
import { CampaignUserTaskStats, totalCampaignUserTaskStats } from '../AdminPage/tools/CampaignsTool/userStats';

export type ExpertSortKey = 'expert' | 'status' | 'total' | keyof CampaignUserTaskStats;
export interface ExpertSort {
  key: ExpertSortKey;
  direction: 'ascending' | 'descending';
}

export function nextExpertSort(current: ExpertSort, key: ExpertSortKey): ExpertSort {
  return {
    key,
    direction: current.key === key
      ? (current.direction === 'ascending' ? 'descending' : 'ascending')
      : (key === 'expert' || key === 'status' ? 'ascending' : 'descending'),
  };
}

export function sortExperts(
  users: User[], campaign: Campaign,
  stats: Map<string, CampaignUserTaskStats> | null, sort: ExpertSort,
): User[] {
  const name = (user: User) => user.displayName || '(no name)';
  const value = (user: User): string | number => {
    if (sort.key === 'expert') return name(user);
    if (sort.key === 'status') {
      return user.expertId ? campaign.alignedCampaignExpertStatuses?.[user.expertId] ?? 'active' : '';
    }
    const counts = stats?.get(user.uid);
    if (!counts) return 0;
    return sort.key === 'total' ? totalCampaignUserTaskStats(counts) : counts[sort.key];
  };
  return [...users].sort((a, b) => {
    const left = value(a);
    const right = value(b);
    const compared = typeof left === 'number' && typeof right === 'number'
      ? left - right
      : String(left).localeCompare(String(right), undefined, { sensitivity: 'base' });
    return compared * (sort.direction === 'ascending' ? 1 : -1)
      || name(a).localeCompare(name(b), undefined, { sensitivity: 'base' })
      || a.uid.localeCompare(b.uid);
  });
}
